<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">
      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            Feedback
            <add-button link="/main/feedbacks/create"></add-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Feedback</li>
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->

      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Client Name</th>
                        <th>Location</th>
                        <th>Description</th>
                        <th>Date</th>
                        <th>Client Signature</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="5"
                      ></loading-table>
                      <router-link
                        v-for="(feedbck, at) in feedbacks"
                        :key="`feedbck${at}`"
                        :to="`/main/feedbacks/${feedbck.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ feedbck.client_name }}</td>
                        <td>{{ feedbck.location }}</td>
                        <td>{{ feedbck.description }}</td>
                        <td>{{ feedbck.created_at }}</td>
                        <td>
                          <img
                            v-if="feedbck.signature_path"
                            :src="mediaUrl + feedbck.signature_path"
                            style="width: 70px; height: 70px"
                          />
                        </td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "feedbacks",
  data() {
    return {
      feedbacks: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    // this.getMasters()
  },
  methods: {
    async getData(page = 1) {
      this.isLoading = true;
      let feedbacks = await axios.get(
        `feedbacks?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      // console.log(feedbacks)
      this.feedbacks = feedbacks.data.data;
      this.count = feedbacks.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    // async getMasters() {
    //   let masters = await axios.get('feedbcks/masters')
    //   masters = masters.data
    // },
  },
};
</script>
